/** Fallback initial when a brand has no logo_url from the backend. */
export function getBrandInitial(brandName) {
    return (brandName || "?").charAt(0).toUpperCase();
}
